export default angular
  .module('gm.wealth.common')
  .filter('gmwSubtractPercentage', gmwSubtractPercentage)
  .name;

function gmwSubtractPercentage() {
  'ngInject';

  return subtractPercentage;

  function subtractPercentage(input, percentage) {
    if (!input || !percentage) {
      return input;
    }
    return input - ((input * percentage) / 100);
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/filters/subtract-percentage.js